import { InvoiceLineItem } from "@jugl-web/rest-api";

export const caltItemPrice = ({ price, qty }: { price: number; qty: number }) =>
  price * qty;

export const calcTotal = (
  total: number,
  discountAmount: number,
  invoiceLevelTax: number
) => total * 100 - discountAmount * invoiceLevelTax;

export const calcDiscountAmount = (
  discount: {
    type: string;
    amount: number | null;
  },
  subtotal: number
): number => {
  const amount = discount.amount ?? 0;
  return discount
    ? discount.type === "percentage"
      ? subtotal * (amount / 100)
      : amount
    : 0;
};

export const getAllPrices = ({
  items,
  discount,
  taxes,
}: {
  items: InvoiceLineItem[];
  discount: {
    type: string;
    amount: number | null;
  };
  taxes: Array<{ percentage: number }>;
}): {
  subtotal: number;
  total: number;
  invoiceTax: number;
  discount: number;
} => {
  const subtotal = items.reduce(
    (acc, item) => acc + caltItemPrice({ price: item.price, qty: item.qty }),
    0
  );
  let discountAmount = 0;
  if (discount?.type === "percentage" && discount.amount) {
    discountAmount = (subtotal / 100) * discount.amount;
  }
  if (discount?.type === "value" && discount.amount) {
    discountAmount = discount.amount;
  }
  let invoiceTax = 0;
  if (taxes.length > 0) {
    taxes.forEach((tax) => {
      invoiceTax +=
        Math.round((subtotal - discountAmount) * (tax.percentage / 100) * 100) /
        100;
    });
  }
  return {
    subtotal,
    discount: discountAmount,
    invoiceTax,
    total: subtotal - discountAmount + invoiceTax,
  };
};
